import React, { FC } from "react";
import styles from "./StatusFilter.module.css";
import clsx from "clsx";
import { useAppDispatch, useAppSelector } from "hooks";
import {
  getLengthAndStatus,
  setStatus,
} from "store/ducks/filterHackathon/slice";
import { All, ComingSoon, Completed, Ongoing, List, Grid } from "assets/svgs";

interface Props {
  view: "grid" | "list";
  setView: React.Dispatch<React.SetStateAction<"grid" | "list">>;
}

const StatusFilter: FC<Props> = ({ view, setView }) => {
  const dispatch = useAppDispatch();
  const { lengths, status } = useAppSelector(getLengthAndStatus);

  const setTab = (sts: any) => {
    dispatch(setStatus(sts));
  };

  return (
    <div className={styles.root}>
      <button
        onClick={() => setTab(undefined)}
        className={clsx(styles.tab, {
          [styles.active]: status.length === 0,
        })}
      >
        <span>
          <All active={status.length === 0} />
        </span>
        All
      </button>

      <button
        onClick={() => setTab("Upcoming")}
        className={clsx(styles.tab, {
          [styles.active]: status.includes("Upcoming"),
        })}
      >
        <span>
          <Ongoing active={status.includes("Upcoming")} />
        </span>
        Coming Soon
      </button>

      <button
        onClick={() => setTab("open")}
        className={clsx(styles.tab, {
          [styles.active]: status.includes("open"),
        })}
      >
        <span>
          <ComingSoon active={status.includes("open")} />
        </span>
        Ongoing
      </button>

      <button
        onClick={() => setTab("ended")}
        className={clsx(styles.tab, {
          [styles.active]: status.includes("ended"),
        })}
      >
        <span>
          <Completed active={status.includes("ended")} />
        </span>
        Completed
      </button>

      <div className={styles.buttonGroup}>
        <button
          onClick={() => setView("grid")}
          className={clsx({ [styles.btnActive]: view === "grid" })}
        >
          <Grid />
        </button>

        <button
          onClick={() => setView("list")}
          className={clsx({ [styles.btnActive]: view === "list" })}
        >
          <List />
        </button>
      </div>
    </div>
  );
};

export default StatusFilter;
